/**!
 * Created by Leonardo Cheslacki on 04/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import SupportController from './SupportController';

import WithType from './../WithType';

class SupportEffect extends SupportController {
    /**
     *
     * @param props
     * @param main
     * @returns {SupportEffect}
     */
    constructor(props, main) {
        super(props);

        // if (SupportEffect._this instanceof SupportEffect) {
        //     return SupportEffect._this;
        // }

        this.props = props;
        this.main = main;

        this.state = {};

        SupportEffect._this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    initStart = () => {
        //const {current_name} = this.props;
        /**
         *
         * Emit start animation.
         */
        //AllTap.emit('animate_start', {}, current_name);
    };

    initComplete = () => {
        const {current_name} = this.props;

        /**
         *
         * Emit complete animation.
         */
        AllTap.emit('animate_complete', {}, current_name);
    };

    initEnd = () => {
        const {current_name} = this.props;

        /**
         *
         * Emit end animation.
         */
        AllTap.emit('animate_end', {}, current_name);
    };

    initLayerComplete = () => {
        const {current_name} = this.props;

        /**
         *
         * Emit end animation.
         */
        AllTap.emit('animate_layer_complete', {}, current_name);
    };

    initLayerEnd = () => {
        const {current_name} = this.props;

        /**
         *
         * Emit end animation.
         */
        AllTap.emit('animate_layer_end', {}, current_name);
    };

    initGalleryComplete = () => {
        const {current_name} = this.props;

        /**
         *
         * Emit end animation.
         */
        AllTap.emit('animate_gallery_complete', {}, current_name);
    };

    initGalleryEnd = () => {
        const {current_name} = this.props;

        /**
         *
         * Emit end animation.
         */
        AllTap.emit('animate_gallery_end', {}, current_name);
    };
}

/**
 *
 * @type {{}}
 */
SupportEffect.propTypes = {
    current_name: PropTypes.string
};

/**
 *
 * @type {{}}
 */
SupportEffect.defaultProps = {
    current_name: null
};

/**
 *
 * @type {{}}
 * @private
 */
SupportEffect._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(SupportEffect, {className: 'SupportEffect'});
